import axios from 'axios';
import { ICrudDeleteAction, ICrudGetAction, ICrudPutAction, IPayloadResult } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';
import { IPayload } from 'react-jhipster/src/type/redux-action.type';
import { IPatientFeedback, IPatientFeedbackDTO, defaultValue } from 'app/shared/model/patient-feedback.model';

export const ACTION_TYPES = {
  FETCH_PATIENT_FEEDBACK_BY_CASE: 'patient-feedback/FETCH_PATIENT_FEEDBACK_BY_CASE',
  FETCH_PATIENT_FEEDBACK: 'patient-feedback/FETCH_PATIENT_FEEDBACK',
  CREATE_PATIENT_FEEDBACK: 'patient-feedback/CREATE_PATIENT_FEEDBACK',
  UPDATE_PATIENT_FEEDBACK: 'patient-feedback/UPDATE_PATIENT_FEEDBACK',
  RESET: 'patient-feedback/RESET'
};

const initialState = {
  loading: false,
  errorMessage: null,
  entity: defaultValue,
  updating: false,
  updateSuccess: false
};

export type PatientFeedbackState = Readonly<typeof initialState>;

// Reducer
export default (state: PatientFeedbackState = initialState, action): PatientFeedbackState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_PATIENT_FEEDBACK_BY_CASE):
    case REQUEST(ACTION_TYPES.FETCH_PATIENT_FEEDBACK):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_PATIENT_FEEDBACK):
    case REQUEST(ACTION_TYPES.UPDATE_PATIENT_FEEDBACK):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_PATIENT_FEEDBACK_BY_CASE):
    case FAILURE(ACTION_TYPES.FETCH_PATIENT_FEEDBACK):
    case FAILURE(ACTION_TYPES.CREATE_PATIENT_FEEDBACK):
    case FAILURE(ACTION_TYPES.UPDATE_PATIENT_FEEDBACK):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_PATIENT_FEEDBACK_BY_CASE):
    case SUCCESS(ACTION_TYPES.FETCH_PATIENT_FEEDBACK):
    case SUCCESS(ACTION_TYPES.CREATE_PATIENT_FEEDBACK):
    case SUCCESS(ACTION_TYPES.UPDATE_PATIENT_FEEDBACK):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: action.type === SUCCESS(ACTION_TYPES.CREATE_PATIENT_FEEDBACK) || action.type === SUCCESS(ACTION_TYPES.UPDATE_PATIENT_FEEDBACK),
        entity: action.payload.data
      };
    case ACTION_TYPES.RESET:
      return {
        ...state,
        loading: false,
        errorMessage: null,
        entity: defaultValue,
        updating: false,
        updateSuccess: false
      };
    default:
      return state;
  }
};

const apiUrl = 'api/patient-feedbacks';

// Actions
export const getPatientFeedbackByPatientCaseId: (patientCaseId: string) => IPayload<IPatientFeedback> | IPayloadResult<IPatientFeedback> = (patientCaseId) => async dispatch => {
  return await dispatch({
    type: ACTION_TYPES.FETCH_PATIENT_FEEDBACK_BY_CASE,
    payload: axios.get<IPatientFeedback>(`${apiUrl}?patientCaseId=${patientCaseId}&cacheBuster=${new Date().getTime()}`)
  });
};

export const getPatientFeedback: ICrudGetAction<IPatientFeedback> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_PATIENT_FEEDBACK,
    payload: axios.get<IPatientFeedback>(requestUrl)
  };
};

export const createPatientFeedback: ICrudPutAction<IPatientFeedbackDTO> = entity => async dispatch => {
  return await dispatch({
    type: ACTION_TYPES.CREATE_PATIENT_FEEDBACK,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
};

export const updatePatientFeedback: ICrudPutAction<IPatientFeedbackDTO> = entity => async dispatch => {
  return await dispatch({
    type: ACTION_TYPES.UPDATE_PATIENT_FEEDBACK,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
